import { render, staticRenderFns } from "./supplierBill.vue?vue&type=template&id=5c51eb40&scoped=true"
import script from "./supplierBill.vue?vue&type=script&lang=js"
export * from "./supplierBill.vue?vue&type=script&lang=js"
import style0 from "./supplierBill.vue?vue&type=style&index=0&id=5c51eb40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c51eb40",
  null
  
)

export default component.exports